import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { checkValidity } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import Phone, { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';

// Components
import * as icons from '../Icons/Icons';

const EnrollSMS = observer(class EnrollSMS extends React.Component {
  constructor() {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.advance = this.advance.bind(this);
    this.back = this.back.bind(this);
  }

  componentWillMount() {
    this.state = {
      phone: null,
      smsStep: 1,
      photoCount: 0
    };
  }

  handleInput(e) {
    this.setState({
      phone: e
    });

    this.props.store.SmarterIDStore.updateEnrollment(e, 'mobileNumber');
  }

  handleSubmit() {
    const { SmarterIDStore } = this.props.store;

    SmarterIDStore.createSIDEnrollment(this.advance);

    // Set an interval to check when the photos have been uploaded
    const _this = this;

    const checkPhotos = setInterval(function(){
      if(_this.state.photoCount > 0 && _this.state.smsStep !== 3) {
        _this.advance();
      } else if(SmarterIDStore.enrollment.status && SmarterIDStore.enrollment.status.toLowerCase() === 'active') {
        clearInterval(checkPhotos);
        _this.props.setStep(null, 5);
        _this.props.setDisplayStep(3);
      } else {
        SmarterIDStore.getSIDEnrollment();
      }
    }, 5000);
  }

  advance() {
    this.setState({
      smsStep: this.state.smsStep + 1
    });
  }

  smsStepActive(step) {
    if(this.state.smsStep === step) {
      return 'fade-active';
    } else {
      return 'fade-hidden';
    }
  }

  back() {
    this.setState({
      smsStep: 1
    });
  }

  handlePC(e) {
    const callback = (e) => {this.props.setStep(e, 4)}

    this.props.store.SmarterIDStore.createSIDEnrollment(callback);
  }

  render() {
    const { translation } = this.props;
    const { SmarterIDStore } = this.props.store;

    return(
      <div className={`panel panel--brief ${this.props.isActive}`}>
        <section className={this.smsStepActive(1)}>
          <h1 className="panel__title">{translation.heading}</h1>

          <p>{translation.body}</p>

          <form className="form-brief enroll-sms" onSubmit={(e) => checkValidity(e, this.handleSubmit, '.enroll-sms')}  noValidate>
            <ul className="fields">
              <li>
                <label className="lbl-required" htmlFor="enroll-phone">{translation.label}</label>

                <Phone
                  id="enroll-phone"
                  nativeExpanded={true}
                  flagsPath="./static/img/flags/"
                  country={parsePhoneNumber(this.state.phone).country || 'US'}
                  onChange={(e) => {this.handleInput(e, 'phone')}}
                  aria-invalid={!isValidPhoneNumber(this.state.phone)}
                  required
                  disabled={this.props.isActive === 'slide-active' ? null : true}
                />
              </li>
            </ul>

            <button className="btn btn--icn-right next" disabled={this.props.isActive === 'slide-active' ? null : true}>
              {translation.button}
              <icons.iconCircleRight />
            </button>

            <span className="preposition--vertical">{translation.or}</span>

            <button
              className="btn--link"
              type="button"
              onClick={(e) => {this.handlePC(e)}}
              disabled={this.props.isActive === 'slide-active' ? null : true}
            >
              {translation.alternative}
            </button>
          </form>
        </section>

        <section className={this.smsStepActive(2)}>
          <h1 className="panel__title">{translation.sent.heading}</h1>

          <p>{translation.sent.body}</p>

          <span className="text-code">{SmarterIDStore.links.enrollmentUrl}</span>

          <img src={SmarterIDStore.links.qrCode} width="150" alt="QR code" />
        </section>

        <section className={this.smsStepActive(3)}>
          <h1 className="panel__title">{translation.processing.heading}</h1>

          <p>{translation.processing.body}</p>
        </section>
      </div>
    );
  }
})

export default translate('EnrollSMS')(EnrollSMS);


// WEBPACK FOOTER //
// ./src/app/components/Enroll/EnrollSMS.js